<template>
  <div class="bb-income">
    <div class="bb-income-tabs">
      <div class="bb-income-tabs-item"
           v-for="(tab, index) in tabs"
           :key="index+tab"
           @click="setActiveTab(index)"
           :class="{'bb-income-tabs-item_active': activeTab === index}">
        <span class="bb-income-tabs-item__number">0{{index + 1}}</span>
        <span class="bb-income-tabs-item__title">{{tab}}</span>
      </div>
    </div>
    <template v-if="activeTab === 0">
      <InvoicesTable :activeTable="activeTable"/>
    </template>
    <template v-else-if="activeTab === 1">
      <BalanceClients/>
    </template>
    <template v-else-if="activeTab === 2">
      <BalancePartners/>
    </template>
  </div>
</template>

<script>
import InvoicesTable from '@/components/Finance/InvoiceTable/InvoicesTable'
import BalanceClients from '@/components/Finance/Income/BalanceClients/BalanceClients'
import BalancePartners from '@/components/Finance/Income/BalancePartners/BalancePartners'

export default {
  name: 'FinanceIncome',
  props: ['activeTable'],
  components: {
    InvoicesTable,
    BalanceClients,
    BalancePartners
  },
  data: function () {
    return {
      tabNames: ['invoice-tracking', 'client-balance', 'partner-payouts'],
      tabs: ['Proforma Invoice Tracker', 'Existing Balances Of Clients', 'Existing Balances Of Partners'],
      activeTab: 0
    }
  },
  methods: {
    setActiveTab (index) {
      if (index === this.activeTab) return
      const tabName = this.tabNames[index]
      this.activeTab = index
      this.$router.push({'name': 'FinanceIncome', 'params': {tab: tabName}})
    }
  },
  beforeMount () {
    const tabName = this.$route.params.tab
    const index = this.tabNames.indexOf(tabName)
    this.activeTab = index === -1 ? 0 : index
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/_variables";
  @import "../../../sass/mixins";

  .bb-income {
    @include global-font;

    &-tabs {
      position: relative;
      z-index: 1;
      display: flex;
      margin-bottom: 25px;

      &-item {
        position: relative;
        display: flex;
        align-items: center;
        min-width: 325px;
        height: 95px;
        overflow: hidden;
        border-radius: 5px;
        background-color: $color-seashell;
        padding-left: 64px;
        padding-right: 20px;
        margin: 0 22px;
        cursor: pointer;
        transition: .3s;
        user-select: none;

        &__btn {
          width: 102px;
          align-self: flex-end;
          margin-left: auto;
        }

        &:hover {
          background-color: rgba($color-silver, 0.2);
        }

        &_active {
          background-color: $color-white;

          &{
            color: $color-accent;
          }

          &:hover {
            background-color: $color-white;
          }
        }

        &__number {
          position: absolute;
          left: -12px;
          color: rgba($color-accent, 0.13);
          font-style: normal;
          font-weight: bold;
          font-size: 50px;
          line-height: 60px;
        }

        &__title {
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          line-height: 24px;
        }

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Finance/Income/Income.vue